import { useEffect, useState } from 'react';

/**
 * Full-screen focus mode for a dense panel (the docx editor + review redline in the Vault,
 * the sections panel on the tech-spec review page): grows the host to fill the viewport for
 * distraction-free work. Escape exits, and the page behind is scroll-locked while active.
 * Shared so the surfaces never drift.
 */
export function useFullscreen() {
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    if (!expanded) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setExpanded(false);
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [expanded]);
  return {
    expanded,
    toggle: () => setExpanded((v) => !v),
    exit: () => setExpanded(false),
  };
}
